/** Largest ordered prefix that fits, reserving More only when there is overflow. */
export function primaryCategoryCount(widths: number[], available: number, moreWidth: number): number {
  let count = widths.length;
  let used = widths.reduce((sum, width) => sum + width, 0);
  if (used <= available) return count;
  while (count > 0 && used + moreWidth > available) {
    used -= widths[--count];
  }
  return count;
}
